module.exports = __webpack_public_path__ + "static/media/4.b7f4ea17.svg";